import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css';
import logoMab from '../../uploads/logo/RyQ.png';

const Navbar = ({ isLoggedIn, handleLogout, handleLoginClick, navigateTo, activeView }) => {
  // Estado para el menú desplegable de usuario (sin cambios)
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  // --- NUEVO ESTADO --- para controlar el menú lateral en móvil
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const dropdownRef = useRef(null);

  // Cierra el menú móvil al hacer clic en un enlace
  const handleNavClick = (e, view) => {
    e.preventDefault();
    navigateTo(view);
    setMobileMenuOpen(false); // <-- AÑADIDO: Cierra el menú lateral
  };

  // --- NUEVA FUNCIÓN --- para abrir/cerrar el menú lateral
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  // Lógica para cerrar el menú de usuario (sin cambios)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const onLoginClick = () => {
    handleLoginClick();
    setDropdownOpen(false);
  };

  const onLogoutClick = () => {
    handleLogout();
    setDropdownOpen(false);
  };

  return (
    // Se usa un Fragment <> para poder tener el menú lateral como hermano del nav
    <>
      <nav className="navbar">
        <div className="navbar-logo">
          <a href="#inicio" onClick={(e) => handleNavClick(e, 'inicio')}>
            {/* TU LOGO ORIGINAL SE MANTIENE INTATCO */}
            <img src={logoMab} alt="Logo R&Q" />
          </a>
        </div>

        {/* --- ENLACES PARA ESCRITORIO --- (Se ocultan en móvil con CSS) */}
        <ul className="navbar-links">
          <li className={activeView === 'inicio' ? 'active' : ''}><a href="#inicio" onClick={(e) => handleNavClick(e, 'inicio')}>Inicio</a></li>
          <li className={activeView === 'proyectos' ? 'active' : ''}><a href="#proyectos" onClick={(e) => handleNavClick(e, 'proyectos')}>Proyecto</a></li>
          <li className={activeView === 'camaras' ? 'active' : ''}><a href="#camaras" onClick={(e) => handleNavClick(e, 'camaras')}>Cámaras</a></li>
          <li className={activeView === 'videos' ? 'active' : ''}><a href="#videos" onClick={(e) => handleNavClick(e, 'videos')}>Videos</a></li>
          <li className={activeView === 'archivo' ? 'active' : ''}><a href="#archivo" onClick={(e) => handleNavClick(e, 'archivo')}>Archivo</a></li>
          <li className={activeView === 'contactos' ? 'active' : ''}><a href="#contactos" onClick={(e) => handleNavClick(e, 'contactos')}>Contactos</a></li>
        </ul>

        <div className="navbar-right-side">
            {/* Menú de usuario (sin cambios) */}
            <div className="navbar-auth" ref={dropdownRef}>
                <button className="user-icon-button" onClick={() => setDropdownOpen(!isDropdownOpen)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                </button>
                {isDropdownOpen && (
                <div className="dropdown-menu">
                    {isLoggedIn ? (
                    <button onClick={onLogoutClick} className="dropdown-item">Cerrar Sesión</button>
                    ) : (
                    <button onClick={onLoginClick} className="dropdown-item">Iniciar Sesión</button>
                    )}
                </div>
                )}
            </div>

            {/* --- NUEVO ICONO DE HAMBURGUESA --- (Solo visible en móvil) */}
            <button className="mobile-menu-icon" onClick={toggleMobileMenu}>
                {isMobileMenuOpen ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                )}
            </button>
        </div>
      </nav>

      {/* --- NUEVO MENÚ LATERAL DESLIZABLE --- */}
      {isMobileMenuOpen && <div className="overlay" onClick={toggleMobileMenu}></div>}
      <div className={`mobile-nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul>
          <li className={activeView === 'inicio' ? 'active' : ''}><a href="#inicio" onClick={(e) => handleNavClick(e, 'inicio')}>Inicio</a></li>
          <li className={activeView === 'proyectos' ? 'active' : ''}><a href="#proyectos" onClick={(e) => handleNavClick(e, 'proyectos')}>Proyecto</a></li>
          <li className={activeView === 'camaras' ? 'active' : ''}><a href="#camaras" onClick={(e) => handleNavClick(e, 'camaras')}>Cámaras</a></li>
          <li className={activeView === 'videos' ? 'active' : ''}><a href="#videos" onClick={(e) => handleNavClick(e, 'videos')}>Videos</a></li>
          <li className={activeView === 'archivo' ? 'active' : ''}><a href="#archivo" onClick={(e) => handleNavClick(e, 'archivo')}>Archivo</a></li>
          <li className={activeView === 'contactos' ? 'active' : ''}><a href="#contactos" onClick={(e) => handleNavClick(e, 'contactos')}>Contactos</a></li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;